export default "__VITE_ASSET__77be55e4__"